import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getDocuments } from "../../redux/actions/actionDocument";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import getMonth from "date-fns/getMonth";
import "react-big-calendar/lib/css/react-big-calendar.css";
import './calendarStyles.css'



export default function Calendario(){
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const documents = useSelector(state => state.documents.allDocuments)

    useEffect(() => {
        dispatch(getDocuments())
    }, [dispatch])

    console.log(documents)

    // const calendarDoc = {
    //     title: "",
    //     allDay: "",
    //     start: "",
    //     end: ""
    // }

    let arrayCalendar = []

    const calendar = documents[0] !== undefined ? documents[0].map(e => {
        //if(e.state === false){
        const calendarDoc = {
            id: e._id,   
            title: "N° Doc " + e.numberDocument + " - " + e.client_id.nameCompany,
            allDay: true,
            start: new Date(e.dateSend),
            end : new Date(e.dateReception),
            state: e.state,
            parcial: e.parcial
        }
        return arrayCalendar.push(calendarDoc)
    //}
    }) 
    : null;
    console.log(arrayCalendar)

    const locales = {
        "en-US": require("date-fns/locale/en-US") //es el area donde refiere nuestro calendario, de momento va por defecto  en-US
    }

    const localizer = dateFnsLocalizer({    // traemos las dife
        format,            //formato de fecha
        parse,             //analizador
        startOfWeek,       //principio de semana
        getDay,            //obtener dia
        getMonth,
        locales             
    })

    const linkDocument = (e) => {
        console.log(e.id)
        navigate(`/documentos/${e.id}`)
        
    } 

    const events = [
        {
            title: "reunion 1",
            allDay: true,
            start: new Date(2023,8,22),
            end: new Date(2023,8,22)
        },
        {
            title: "reunion 2",
            allDay: true,
            start: new Date(2023,8,22),
            end: new Date(2023,8,22)
        },
        {
            title: "reunion 3",
            allDay: true,
            start: new Date(2023,8,22),
            end: new Date(2023,8,22)
        }
    ]

    const components = {
        event: (props) => {
            //console.log("props", props.event);
            const eventState = props.event;
            console.log(eventState.state)
            if(eventState.state === true){
                return <div className="bg-green-400 text-[8pt] text-black font-bold">{eventState.title}</div>
            }
            if(eventState.parcial === false && eventState.state === false){
                return <div className="bg-red-500 text-[8pt] text-white font-bold">{eventState.title}</div>
            }
            if(eventState.parcial === true && eventState.state === false){
                return <div className="bg-yellow-300 text-[8pt] text-black font-bold">{eventState.title}</div>
            }
        }
    }

    
    //{height: 1000, margin:"10px", color: "#f97316"}

    return (
        <div className="container bg-gray-900">
            <div className="m-4">
            <div className="ml-2 mb-4 text-[18pt] font-semibold text-orange-500">Calendario</div>
            <div className="flex text-center ml-2 w-1/3 bg-slate-600">
              <p className="text-green-400 text-[10pt] font-bold w-1/3">SALDADO</p>
              <p className="text-red-500 text-[10pt] font-bold w-1/3">NO SALDADO</p>
              <p className="text-yellow-500 text-[10pt] font-bold w-1/3">PARCIAL</p>  
            </div>
             <div className="">
                <Calendar 
                    localizer={localizer}
                    events={arrayCalendar}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 1000, margin:"10px", color: "#f97316"}}
                    showAllEvents
                    components={components}
                    //onDoubleClickEvent={linkDocument}
                    onSelectEvent={linkDocument}
                    
                />                
             </div>
            </div>
         </div>
    )
}